import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getBaseURL } from "../pages/constants";

export const BASE_URL = getBaseURL();
export const ResourceAssessmentApi = createApi({
  reducerPath: "ResourceAssessmentApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  mode: "cors",
  tagTypes: ["ResourceAssessments"],
  endpoints: (builder) => ({
    // resource assessments
    deleteResourceAssessment: builder.mutation({
      query: (params) => {
        return {
          url: `bandobast/${params.bandobastId}/timeslots/${params.timeslotId}/locations/${params.locationId}/resourceAssessments/${params.resourceAssessmentId}`,
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        };
      },
      invalidatesTags: ["ResourceAssessments"],
    }),
    modifyResourceAssessment: builder.mutation({
      query: (params) => {
        return {
          url: `bandobast/${params.bandobastId}/locations/${params.locationId}/resourceAssessments/${params.resourceAssessmentId}`,
          method: "PUT",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(params.body),
        };
      },
      invalidatesTags: ["ResourceAssessments"],
    }),
    getResourceAssessmentsOfLocation: builder.query({
      query: (params) => {
        return {
          url: `bandobast/${params.bandobastId}/timeslots/${params.timeslotId}/locations/${params.locationId}/resourceAssessments`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        };
      },
      provideTags: ["ResourceAssessments"],
    }),
    getResourceAssessmentsOfTimeslot: builder.query({
      query: (params) => {
        return {
          url: `bandobast/${params.bandobastId}/timeslots/${params.timeslotId}/resourceAssessments`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        };
      },
      provideTags: ["ResourceAssessments"],
    }),
    newResourceAssessment: builder.mutation({
      query: (params) => {
        return {
          url: `bandobast/${params.bandobastId}/timeslots/${params.timeslotId}/locations/${params.locationId}/resourceAssessments`,
          method: "POST",
          headers: {
            authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(params.body),
        };
      },
      invalidatesTags: ["ResourceAssessments"],
    }),
  }),
});

export const {
  // resource assessments (of locations)
  useNewResourceAssessmentMutation,
  useDeleteResourceAssessmentMutation,
  useModifyResourceAssessmentMutation,
  useGetResourceAssessmentsOfTimeslotQuery,
  useGetResourceAssessmentsOfLocationQuery,
} = ResourceAssessmentApi;
